'use client';

import { useRelatedProducts } from '@eliadmin/core/src/hooks/products/use-related-products';
import { RelatedProductsStatus } from '@eliadmin/core/src/components/product/detail/related-products-status';
import { RelatedProducts } from '../../components/product/detail/related-products';

export function ProductRelatedProducts({ slug }: { slug: string }) {
  const related = useRelatedProducts(slug);
  if (!related.enabled || (!related.products.length && !related.isLoading && !related.isError)) {
    return null;
  }

  return (
    <>
      {related.products.length > 0 && <RelatedProducts products={related.products} />}
      <div className="custom-container">
        <RelatedProductsStatus
          loading={related.isLoading}
          error={related.isError}
          retry={() => { void related.refetch(); }}
        />
      </div>
    </>
  );
}
